import { addStyles } from 'ethcss'
import { colors, IStyles, mediaCSS } from '../../../theme'

const styles: IStyles = {
    wrapper: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    addLicenses: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        padding: 30,
        width: 960,
        borderRadius: 20,
        minHeight: 600,

        [mediaCSS.tab]: {
            width: '96%',
        },

        [mediaCSS.tabMini]: {
            minHeight: 0,
            padding: 20,
        },
    },
    title: {
        fontSize: 18,
        textAlign: 'center',
    },
    description: {
        color: colors.grey,
        marginTop: 8,
        marginBottom: 30,
        textAlign: 'center',
    },
    licenseSelector: {
        display: 'flex',
        alignItems: 'center',

        span: {
            marginRight: 20,

            [mediaCSS.tabMini]: {
                display: 'block',
                margin: '0 0 14px 0',
            },
        },

        [mediaCSS.tabMini]: {
            display: 'block',
        },
    },
    licenseDropdown: {
        minWidth: 450,
        height: 56,

        [mediaCSS.tabMini]: {
            height: 'auto',
            minWidth: 0,
        },
    },
    devicesColRight: {
        [mediaCSS.tabMini]: {
            paddingRight: 48,
        },
    },
    disabled: {
        opacity: 0.5,
    },
    notAvailable: {
        marginTop: 20,
    },
    noLicensesLeft: {
        display: 'flex',
        color: colors.notificationRed,

        span: {
            marginLeft: 10,
            fontSize: 11,
        },
    },
    licenseOption: {
        padding: 6,
        borderRadius: 5,
        backgroundColor: 'transparent',
        width: '100%',
        transition: 'background-color 0.3s',

        '&:hover': {
            backgroundColor: '#E9ECF1',
        },

        [mediaCSS.tabMini]: {
            border: `1px solid ${colors.greyLight}`,
        },
    },
    licenseOptionRow: {
        display: 'flex',
        justifyContent: 'space-between',

        [mediaCSS.tabMini]: {
            display: 'block',
        },
    },
    licenseOptionMob: {
        [mediaCSS.tabMini]: {
            display: 'none !important',
        },
    },
    licenseOptionName: {
        fontWeight: 'bold',
    },
    licenseOptionDesc: {
        borderRadius: 5,
        backgroundColor: '#F2F4F7',
        fontWeight: 'normal',

        span: {
            color: colors.blueAccent,

            span: {
                color: 'rgba(37, 130, 224, 0.50)',
            },
        },
    },
    licenseHeaderDesc: {
        borderRadius: 5,
        backgroundColor: 'transparent',
        fontWeight: 'normal',

        span: {
            color: colors.blueAccent,

            span: {
                color: 'rgba(37, 130, 224, 0.50)',
            },
        },
    },
    lic: {
        [mediaCSS.tabMini]: {
            width: '100%',
        },
    },
    devicesSection: {
        marginTop: 20,
    },
    devicesRow: {
        display: 'flex',
        position: 'relative',
    },
    devicesCol: {
        display: 'flex',
        alignItems: 'center',
        width: '50%',
        height: 42,
        padding: 10,
        borderLeft: `1px solid ${colors.greyLight}`,
        borderRight: `1px solid ${colors.greyLight}`,
        borderBottom: `1px solid ${colors.greyLight}`,
    },
    devicesHeader: {
        background: colors.greyLight,
        borderRadius: '5px 5px 0 0',
        fontWeight: 600,
        overflow: 'hidden',
    },
    devicesList: {
        minHeight: 300,
        maxHeight: 500,
        overflow: 'auto',
    },
    removeDevice: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        right: 20,
        top: '50%',
        transform: 'translateY(-50%)',
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: colors.greyLight,
        color: colors.offline,
        lineHeight: 0.3,
        fontSize: 24,
        paddingLeft: 1,
        cursor: 'pointer',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20,
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        margin: '0 10px',
        width: 120,
    },
    loader: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    emptyText: {
        fontSize: 18,
        textAlign: 'center',
    },
    closeButton: {
        position: 'absolute',
        bottom: 30,
        left: '50%',
        transform: 'translateX(-50%)',
    },
}

addStyles(styles)
export default styles
